import { LOCALE_ID, Inject, Injectable } from '@angular/core';
import { CalendarEventTitleFormatter, CalendarEvent } from 'angular-calendar';
import { formatDate } from '@angular/common';

@Injectable()
export class CustomEventTitleFormatter extends CalendarEventTitleFormatter {
  constructor(@Inject(LOCALE_ID) private locale: string) {
    super();
  }

  // you can override any of the methods defined in the parent class

  month(event: CalendarEvent): string {
    return `<b>${formatDate(event.start, 'h:m a', this.locale)}</b> ${event.title}`;
  }

  week(event: CalendarEvent): string {
    if (event.meta.ecr != null && event.meta.ecr.wtc_first_level_slug == 'reminders' && event.meta.ecr.custom_title != null) {
      return `
        <span class="title">
          ${event.meta.ecr.custom_title}
        </span>
      `;
    } else {
      return `
        <span class="title">
          ${event.title}
        </span>
        <br>
        ${(event as any).subtitle != null ? '<span class="subtitle">' + (event as any).subtitle + '</span><br>' : ''}
        ${(event as any).company_product_phase_name != null ? '<span class="company_product_phase_name">' + (event as any).company_product_phase_name + '</span>' : ''}
      `;
    }
  }

  day(event: CalendarEvent): string {
    return `<b>${formatDate(event.start, 'h:m a', this.locale)}</b> ${event.title}`;
  }
}
